/*
 * Copyright (c) 2026 Talent Catalog.
 *
 * This program is free software: you can redistribute it and/or modify it under
 * the terms of the GNU General Public License as published by the Free
 * Software Foundation, either version 3 of the License, or any later version.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or
 * FITNESS FOR A PARTICULAR PURPOSE. See the GNU General Public License
 * for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program. If not, see https://www.gnu.org/licenses/.
 */

import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {CandidateService} from '../../../../services/candidate.service';
import {Candidate} from '../../../../model/candidate';

@Component({
  selector: 'app-delete-candidate',
  templateUrl: './delete-candidate.component.html',
  styleUrls: ['./delete-candidate.component.scss']
})
export class DeleteCandidateComponent implements OnInit {

  candidate: Candidate;
  deleting: boolean;

  constructor(private activeModal: NgbActiveModal,
              private candidateService: CandidateService) { }

  ngOnInit() {
  }

  cancel() {
    this.activeModal.dismiss();
  }

  confirm() {
    this.deleting = true;
    this.candidateService.delete(this.candidate.id).subscribe(result => {
      this.deleting = false;
      this.activeModal.close();
    });
  }
}
